import React from 'react';
import ReactDOM from 'react-dom/client';

// Silence non-error console output in production
if (process.env.NODE_ENV === 'production') {
  var noop = function() {};
  console.log = noop;
  console.info = noop;
  console.debug = noop;
  console.warn = noop;
  console.trace = noop;
  console.table = noop;
  console.group = noop;
  console.groupCollapsed = noop;
  console.groupEnd = noop;
}

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null, info: null };
  }
  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }
  componentDidCatch(error, info) {
    this.setState({ info });
    console.error('React crash:', error, info?.componentStack);
  }
  render() {
    if (this.state.hasError) {
      return React.createElement('div', {
        style: {
          padding: 24, color: '#E8EAF0', fontFamily: 'system-ui',
          textAlign: 'center', marginTop: '20vh', background: '#0F1117',
          minHeight: '100vh', boxSizing: 'border-box',
        }
      },
        React.createElement('p', { style: { fontSize: 18, fontWeight: 700 } }, 'LoadStruct Admin'),
        React.createElement('p', { style: { fontSize: 14, color: '#EF4444', margin: '12px 0 8px' } }, 'App crashed'),
        React.createElement('pre', {
          style: {
            fontSize: 11, color: '#8B90A0', textAlign: 'left', maxWidth: 340,
            margin: '0 auto', whiteSpace: 'pre-wrap', wordBreak: 'break-all',
            background: '#1A1D27', padding: 12, borderRadius: 8,
          }
        }, String(this.state.error) + '\n\n' + (this.state.info?.componentStack || '').slice(0, 500)),
        React.createElement('button', {
          onClick: function() { window.location.reload(); },
          style: {
            marginTop: 20, padding: '10px 24px', background: '#3B82F6',
            color: '#fff', border: 'none', borderRadius: 8, fontSize: 14,
            fontWeight: 600, cursor: 'pointer',
          }
        }, 'Reload')
      );
    }
    return this.props.children;
  }
}

// Lazy import so if the module itself has a parse/init error, we catch it
async function bootApp() {
  var rootEl = document.getElementById('root');
  try {
    var mod = await import('./AdminPortal');
    var AdminPortal = mod.default;
    var root = ReactDOM.createRoot(rootEl);
    root.render(
      React.createElement(ErrorBoundary, null,
        React.createElement(AdminPortal)
      )
    );
  } catch (err) {
    console.error('Boot failed:', err);
    rootEl.innerHTML =
      '<div style="padding:24px;color:#E8EAF0;font-family:system-ui;text-align:center;margin-top:20vh">' +
      '<p style="font-size:18px;font-weight:700">LoadStruct Admin</p>' +
      '<p style="font-size:14px;color:#EF4444;margin:12px 0">Failed to load</p>' +
      '<pre style="font-size:11px;color:#8B90A0;text-align:left;max-width:340px;margin:0 auto;white-space:pre-wrap;word-break:break-all;background:#1A1D27;padding:12px;border-radius:8px">' +
      (err ? (err.message || String(err)) : 'Unknown error') + '</pre>' +
      '<button onclick="location.reload()" style="margin-top:20px;padding:10px 24px;background:#3B82F6;color:#fff;border:none;border-radius:8px;font-size:14px;font-weight:600;cursor:pointer">Reload</button></div>';
  }
}

bootApp();
